import {ContentType, HttpClient, RequestParams} from "./http-client";

export class AssetMultipart<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Asset
   * @name CreateAsset
   * @request POST:/asset/create_asset
   */
  createAssetCreate = (data: any, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/create_asset`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
}